module.exports = require("@comparaonline/common-schema");